module.exports = __webpack_public_path__ + "img/中型水库.406d11e0.png";